export default "__VITE_ASSET__DHq$n0Xz__"